import {
  PointerSensor,
  KeyboardSensor,
  useSensors,
  useSensor,
} from '@dnd-kit/core';

// by default dnd-kit uses pointer and keyboard sensors.
// see: https://docs.dndkit.com/api-documentation/sensors
// but the default pointer sensor config prevents click events,
// which we would like to keep.
// so we need to create a custom pointer sensor with a custom activation constraint.
export function useCustomSensors() {
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 0.01,
    },
  });
  const keyboardSensor = useSensor(KeyboardSensor);
  const sensors = useSensors(keyboardSensor, pointerSensor);

  return sensors;
}
